import { useState } from 'react';

import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useTranslation } from 'react-i18next';

import {
  AbsenceFormation,
  AdditionalFormation,
  Formation
} from 'components/types';

import { displayNumber, displayPercentage } from 'utils/misc';

import {
  Collapse,
  IconButton,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';
import { NumericTableCell } from 'components/shared/Table';

import DetailTable from './DetailTable';

type Props = {
  formation: Formation | AdditionalFormation | AbsenceFormation;
  rowName: string;
};

const CollapsibleFormationTableRow = (props: Props) => {
  const { formation, rowName } = props;
  const { formationPercentage, totalYearHours, periodHours } = formation;

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { t } = useTranslation('common');

  let detailFormations;

  if ('employeeFormations' in formation) {
    detailFormations = formation.employeeFormations;
  } else if ('additionalFormations' in formation) {
    detailFormations = formation.additionalFormations;
  } else if ('absenceTypeFormations' in formation) {
    detailFormations = formation.absenceTypeFormations;
  }

  return (
    <>
      <TableRow
        sx={{ cursor: 'pointer' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <TableCell align="left" width="46px">
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            <FontAwesomeSvgIcon
              icon={isExpanded ? faChevronUp : faChevronDown}
              fontSize="small"
            />
          </IconButton>
        </TableCell>
        <TableCell colSpan={6}>{t(`formationTypes.${rowName}`)}</TableCell>
        {periodHours.map(({ number, hours }) => (
          <NumericTableCell key={`${rowName}_${number}`}>
            {displayNumber(Math.round(hours))}
          </NumericTableCell>
        ))}
        <NumericTableCell>
          {displayNumber(Math.round(totalYearHours))}
        </NumericTableCell>
        <NumericTableCell sx={{ width: '62px' }}>
          {displayPercentage(formationPercentage)}
        </NumericTableCell>
      </TableRow>
      <TableRow>
        <TableCell sx={{ padding: 0 }} colSpan={9 + periodHours.length}>
          <Collapse in={isExpanded} unmountOnExit>
            <TableContainer>
              <OverlayScrollbarsComponent
                style={{ maxHeight: '30vh' }}
                options={{
                  paddingAbsolute: true
                }}
              >
                <DetailTable
                  formations={detailFormations}
                  shouldShowExcludeOption={rowName === 'grossFormation'}
                />
              </OverlayScrollbarsComponent>
            </TableContainer>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CollapsibleFormationTableRow;
